var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.17508 16.6807C13.3218 16.6807 16.6834 13.3191 16.6834 9.1724C16.6834 5.02566 13.3218 1.66406 9.17508 1.66406C5.02834 1.66406 1.66675 5.02566 1.66675 9.1724C1.66675 13.3191 5.02834 16.6807 9.17508 16.6807Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.325 15.7917C18.05 15.2833 17.4666 15 16.6833 15C16.0916 15 15.5833 15.2417 15.2833 15.6583C14.9833 16.075 14.9166 16.6333 15.1 17.1917C15.4583 18.275 16.0833 18.5167 16.425 18.5583C16.475 18.5667 16.525 18.5667 16.5833 18.5667C16.95 18.5667 17.5166 18.4083 18.0666 17.5833C18.5083 16.9417 18.5916 16.3 18.325 15.7917Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.e617ddcee9caa7368b1c32d2cad727c3.svg";
export { ForwardRef as ReactComponent };